import React, { useEffect, useState } from "react";
import { Routes, Route } from "react-router-dom";
import Cookies from "js-cookie";
import "./App.css";
import Home from "./pages/Home";
import AboutMe from "./pages/AboutMe";
import Beauty from "./pages/Beauty";
import UsEuropeCountries from "./components/partials/Beauty/us-europe-countries";
import GccProduct from "./components/partials/Beauty/gcc-product";
import MyBlogs from "./pages/MyBlogs";
import Business from "./pages/Business";
import GccBusiness from "./components/partials/Business/GccBusiness";
import BeautyBlog from "./pages/BeautyBlog";
import BusinessOtherCountries from "./components/partials/Business/Business-other-countries";
import Page404 from "./pages/Page404";
import CategoryDetail from "./pages/CategoryDetail";
import Order from "./pages/Order";

function App() {
  const [language, setLanguage] = useState("en");

  useEffect(() => {
    const lang = Cookies.get("RashaLang");
    if (!lang) {
      Cookies.set("RashaLang", "en", { expires: 365 });
      setLanguage("en");
    } else {
      setLanguage(lang);
    }
  }, []);

  return (
    <Routes>
      <Route path="/" element={<Home language={language} />} />
      <Route path="/about-me" element={<AboutMe language={language} />} />
      <Route path="/beauty" element={<Beauty />} />
      <Route path="/us-europe-countries" element={<UsEuropeCountries />} />
      <Route path="/gcc-product" element={<GccProduct />} />
      <Route path="/my-blogs" element={<MyBlogs />} />
      <Route path="/business" element={<Business />} />
      <Route path="/gcc-business" element={<GccBusiness />} />
      <Route path="/beauty-blog" element={<BeautyBlog />} />
      <Route
        path="/business-other-countries"
        element={<BusinessOtherCountries />}
      />
      <Route path="/order" element={<Order />} />
      <Route path="/:name/:id" element={<CategoryDetail />} />

      <Route path="/*" element={<Page404 />} />
    </Routes>
  );
}

export default App;
